import React from 'react'
import "./Announcement_card.css"

function Announcement_card() {
  return (
<>
<section className='Announcement_card'>
    <div className='heading_hodler'>
        <h6><div className='icon_img_holder'><img src='/assets/images/icons/announcement.png' className='icon_img' alt='img icon'/></div>ANNOUNCEMENT!!!</h6>
        <p>The website upgrade is complete. Before logging in, clear the browser cache. Add member betting rewards & VIP level rewards</p>
        <span>2023-08-08 | 22:19:25</span>
    </div>
</section>
</>
  )
}

export default Announcement_card